import React from 'react';
import styled from 'styled-components';
import Icon from 'components/_UI/Icon';
import breakpoints from 'theme/breakpoints';
import colors from 'theme/colors';
import { ui } from 'theme/discover';

/**
 * Características dos lugares ("Aceita animais", "Wi-Fi"...), cada uma abrindo
 * a busca já filtrada — a seção que só a aba Lugares tem no app
 * (EstablishmentFeaturesSection). Faixa de lado no celular, grade no desktop.
 */
export default function EstablishmentFeaturesSection({ features = [], onFeatureClick }) {
    if (!features?.length) return null;

    return (
        <Tiles>
            {features.map(feature => (
                <Tile key={feature.id} type='button' onClick={() => onFeatureClick(feature)}>
                    <IconDisc>
                        <Icon name={feature.icon} color={ui.link} />
                    </IconDisc>
                    <span>{feature.name}</span>
                </Tile>
            ))}
        </Tiles>
    );
}

const Tiles = styled.div`
    display: flex;
    gap: 10px;
    width: calc(100% + 32px);
    margin: -4px -16px 0;
    padding: 4px 16px 12px;
    overflow-x: auto;
    scrollbar-width: none;

    &::-webkit-scrollbar {
        display: none;
    }

    @media screen and (min-width: ${breakpoints.lg}) {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(112px, 1fr));
        width: 100%;
        margin: 0;
        padding: 0;
        overflow: visible;
    }
`;

const Tile = styled.button`
    flex: 0 0 104px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    padding: 14px 8px;
    border-radius: 18px;
    border: none;
    font: inherit;
    font-size: 12px;
    font-weight: 700;
    line-height: 1.3;
    text-align: center;
    color: ${ui.ink};
    background: ${colors.neutralLight};
    box-shadow: ${ui.cardShadow};
    cursor: pointer;
    transition: transform 0.2s ease, box-shadow 0.2s ease;

    & > span {
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }

    &:hover {
        transform: translateY(-2px);
        box-shadow: ${ui.cardShadowHover};
    }

    &:focus-visible {
        outline: 2px solid ${ui.link};
        outline-offset: 2px;
    }

    @media (prefers-reduced-motion: reduce) {
        &:hover {
            transform: none;
        }
    }
`;

const IconDisc = styled.span`
    width: 40px;
    height: 40px;
    padding: 10px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${ui.tagBg};

    & > svg {
        width: 20px;
        height: 20px;
    }
`;
